document.addEventListener('DOMContentLoaded', function () {
    const filterDetails = document.querySelector('.filter[detached="true"]');
    if (!filterDetails) return;

    filterDetails.addEventListener('toggle', function () {
        if (filterDetails.open) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    });

    // Close drawer when clicking on the backdrop (outside details-menu)
    filterDetails.addEventListener('click', function (e) {
        const menu = filterDetails.querySelector('details-menu');
        if (filterDetails.open && menu && !menu.contains(e.target) && e.target !== filterDetails.querySelector('summary')) {
            filterDetails.removeAttribute('open');
        }
    });
});


// dot-sync.js - add this as a new file, no need to edit media-gallery.js

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('media-gallery').forEach((gallery) => {
    const counter = gallery.querySelector('.slider-counter--current');
    const dots = gallery.querySelectorAll('.slider-dot');

    if (!counter || !dots.length) return;

    const syncDots = () => {
      const activeIndex = parseInt(counter.textContent.trim(), 10) - 1;
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === activeIndex);
      });
    };

    // Run once on load
    syncDots();

    // Watch for text changes made by media-gallery.js
    const observer = new MutationObserver(syncDots);
    observer.observe(counter, { childList: true, characterData: true, subtree: true });
  });
});

// autoplay-slider.js
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('slider-component[id^="GalleryViewer-"]').forEach((slider) => {
    const AUTOPLAY_DELAY = 3000; // 3 seconds
    let autoplayInterval;

    // ---- 1. AUTOPLAY WITH LOOP ----
    // Same logic SlideshowComponent uses internally, applied to the PDP's base slider-component
    const tick = () => {
      if (!slider.slider || !slider.sliderItems || slider.sliderItems.length <= 1) return;

      const isLastSlide = slider.currentPage === slider.sliderItems.length;
      const nextPosition = isLastSlide
        ? 0
        : slider.slider.scrollLeft + slider.sliderItemOffset;

      slider.setSlidePosition(nextPosition);
    };

    const startAutoplay = () => {
      if (!slider.sliderItems || slider.sliderItems.length <= 1) return;
      autoplayInterval = setInterval(tick, AUTOPLAY_DELAY);
    };
    const stopAutoplay = () => clearInterval(autoplayInterval);

    startAutoplay();
    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);
    slider.addEventListener('touchstart', stopAutoplay, { passive: true });

    // ---- 2. DOT SYNC ----
    // slider-component already dispatches 'slideChanged' on every scroll/update — real hook, no guessing
    const dots = slider.closest('media-gallery')?.querySelectorAll('.slider-dot');
    if (dots && dots.length) {
      slider.addEventListener('slideChanged', (event) => {
        const activeIndex = event.detail.currentPage - 1; // currentPage is 1-indexed
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === activeIndex));
      });
    }
  });
});


// ============================================================
// QUICK BUY — Complete JS
// ============================================================

// ===== Helper: get currently selected variant ID for a form, computed fresh =====
function getSelectedVariantId(form) {
    return new Promise(function (resolve) {
        var pickerRoot = form.querySelector('coretex-variant-picker');

        // No variant picker = single variant product, hidden input is reliable
        if (!pickerRoot) {
            var singleInput = form.querySelector('.variant-id-input');
            resolve(singleInput ? singleInput.value : null);
            return;
        }

        // Collect selected values fresh from the DOM right now
        var selectedValues = [];
        pickerRoot.querySelectorAll('.variant-option').forEach(function (fs) {
            var selectedBtn = fs.querySelector('.optionValueButton.is-selected');
            var selectedSelect = fs.querySelector('.optionValueSelector');
            if (selectedBtn) {
                selectedValues.push(selectedBtn.dataset.value);
            } else if (selectedSelect) {
                selectedValues.push(selectedSelect.value);
            }
        });

        var productUrl = pickerRoot.dataset.productUrl;
        if (!productUrl) {
            resolve(null);
            return;
        }

        fetch(productUrl + '.js')
            .then(function (res) { return res.json(); })
            .then(function (productData) {
                var matchedVariant = productData.variants.find(function (variant) {
                    return variant.options.every(function (optValue, index) {
                        return optValue === selectedValues[index];
                    });
                });
                resolve(matchedVariant ? matchedVariant.id : null);
            })
            .catch(function () {
                resolve(null);
            });
    });
}

document.addEventListener('click', function (e) {
    var overlay = document.querySelector('[data-qb-overlay]');
    var qbPopup = document.querySelector('[data-qb-popup]');
    var sgPopup = document.querySelector('[data-sg-popup]');
    var qbBody = document.querySelector('[data-qb-body]');
    var sgBody = document.querySelector('[data-sg-body]');

    // ===== Open quick-buy popup (fetch real product data) =====
    var qbTrigger = e.target.closest('[data-qb-trigger]');
    if (qbTrigger) {
        var wrap = qbTrigger.closest('[data-qb-wrap]');
        var productUrl = wrap.dataset.productUrl;

        qbTrigger.classList.add('is-loading');

        overlay.hidden = false;
        qbPopup.hidden = false;
        qbBody.innerHTML = '<div class="qbLoading">Loading...</div>';
        sgBody.innerHTML = '<div class="qbLoading">Loading...</div>';

        fetch(productUrl + '?section_id=x-quickbuy')
            .then(function (res) { return res.text(); })
            .then(function (html) {
                var temp = document.createElement('div');
                temp.innerHTML = html;

                var qvFragment = temp.querySelector('[data-qv-fragment]');
                var sgFragment = temp.querySelector('[data-sg-fragment]');

                qbBody.innerHTML = qvFragment ? qvFragment.innerHTML : '<p class="qbError">Something went wrong.</p>';
                sgBody.innerHTML = sgFragment ? sgFragment.innerHTML : '<p class="qbPlaceholder">No size chart available.</p>';
            })
            .catch(function () {
                qbBody.innerHTML = '<p class="qbError">Something went wrong.</p>';
            })
            .finally(function () {
                qbTrigger.classList.remove('is-loading');
            });
        return;
    }

    // ===== Open size-guide popup (already loaded above) =====
    if (e.target.closest('[data-sg-trigger]')) {
        sgPopup.hidden = false;
        return;
    }

    // ===== Close right popup (also closes left) =====
    if (e.target.closest('[data-qb-close]')) {
        qbPopup.hidden = true;
        sgPopup.hidden = true;
        overlay.hidden = true;
        return;
    }

    // ===== Close left popup only =====
    if (e.target.closest('[data-sg-close]')) {
        sgPopup.hidden = true;
        return;
    }

    // ===== Overlay click closes everything =====
    if (e.target === overlay) {
        qbPopup.hidden = true;
        sgPopup.hidden = true;
        overlay.hidden = true;
        return;
    }

    // ===== Variant picker: handle size button clicks (visual selection) =====
    var optBtn = e.target.closest('.optionValueButton');
    if (optBtn && !optBtn.disabled) {
        var fieldset = optBtn.closest('.variant-option');
        var pickerRoot = optBtn.closest('coretex-variant-picker');
        if (fieldset && pickerRoot) {

            // Toggle selected state within this option group only
            fieldset.querySelectorAll('.optionValueButton').forEach(function (btn) {
                btn.classList.remove('is-selected');
            });
            optBtn.classList.add('is-selected');

            // Update the visible "selected value" text next to option name
            var selectedValueSpan = fieldset.querySelector('[data-selected-value]');
            if (selectedValueSpan) {
                selectedValueSpan.textContent = optBtn.dataset.value;
            }

            // Collect all currently selected option values across all fieldsets, in order
            var selectedValues = [];
            pickerRoot.querySelectorAll('.variant-option').forEach(function (fs) {
                var selectedBtn = fs.querySelector('.optionValueButton.is-selected');
                var selectedSelect = fs.querySelector('.optionValueSelector');
                if (selectedBtn) {
                    selectedValues.push(selectedBtn.dataset.value);
                } else if (selectedSelect) {
                    selectedValues.push(selectedSelect.value);
                }
            });

            var productUrl2 = pickerRoot.dataset.productUrl;
            if (productUrl2) {
                fetch(productUrl2 + '.js')
                    .then(function (res) { return res.json(); })
                    .then(function (productData) {
                        var matchedVariant = productData.variants.find(function (variant) {
                            return variant.options.every(function (optValue, index) {
                                return optValue === selectedValues[index];
                            });
                        });

                        var form = pickerRoot.closest('form');
                        var hiddenInput = pickerRoot.querySelector('.variant-id-input');
                        var submitBtn = form ? form.querySelector('[data-qv-submit]') : null;
                        var priceEl = form ? form.closest('[data-qv-fragment]').querySelector('.qvPrice') : null;

                        if (matchedVariant) {
                            if (hiddenInput) hiddenInput.value = matchedVariant.id;
                            if (submitBtn) submitBtn.disabled = !matchedVariant.available;

                            if (priceEl && matchedVariant.price != null) {
                                var formattedPrice = (matchedVariant.price / 100).toLocaleString('en-IN', {
                                    style: 'currency',
                                    currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR',
                                    minimumFractionDigits: 0
                                });
                                priceEl.textContent = formattedPrice;
                            }
                        } else {
                            if (hiddenInput) hiddenInput.value = '';
                            if (submitBtn) submitBtn.disabled = true;
                        }
                    })
                    .catch(function (err) {
                        console.error('Variant lookup failed:', err);
                    });
            }
        }
        return;
    }

    // ===== Buy Now — computes variant fresh at click time =====
    var buyNowBtn = e.target.closest('[data-qv-buy-now]');
    if (buyNowBtn) {
        var buyForm = buyNowBtn.closest('form');
        if (!buyForm) return;

        buyNowBtn.disabled = true;
        buyNowBtn.textContent = 'Please wait...';

        getSelectedVariantId(buyForm).then(function (variantId) {
            if (!variantId) {
                console.error('Could not determine selected variant.');
                buyNowBtn.disabled = false;
                buyNowBtn.textContent = 'Buy Now';
                return;
            }

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ id: variantId, quantity: 1 })
            })
            .then(function (res) { return res.json(); })
            .then(function () {
                window.location.href = '/checkout';
            })
            .catch(function (err) {
                console.error('Buy now failed:', err);
                buyNowBtn.disabled = false;
                buyNowBtn.textContent = 'Buy Now';
            });
        });
        return;
    }
});

// ===== Add to Cart — verify correct variant, then let theme's native submit handle the rest =====
document.addEventListener('submit', function (e) {
    var form = e.target.closest('.qvForm');
    if (!form) return;

     // Second pass: variant already verified, let native submission proceed
    if (form.dataset.qvVariantVerified === 'true') {
        delete form.dataset.qvVariantVerified;

        var submitBtn = form.querySelector('[data-qv-submit]');
        if (submitBtn) {
            submitBtn.classList.add('is-loading');
        }

        // Show a full-popup loading state so the user knows something is happening
        var qbBodyEl = document.querySelector('[data-qb-body]');
        if (qbBodyEl) {
            qbBodyEl.classList.add('qbBodyProcessing');
        }

        // Wait for the theme's cart drawer to actually open, then close our popup.
        // Falls back to a fixed delay if we can't detect it.
        waitForCartDrawerAndClosePopup();

        return; // no preventDefault — let it submit natively
    }

    // First pass: intercept, resolve correct variant, then re-submit
    e.preventDefault();
    e.stopImmediatePropagation();

    var submitBtn2 = form.querySelector('[data-qv-submit]');
    if (submitBtn2) submitBtn2.classList.add('is-loading');

    getSelectedVariantId(form).then(function (variantId) {
        if (!variantId) {
            console.error('Could not determine selected variant.');
            if (submitBtn2) submitBtn2.classList.remove('is-loading');
            return;
        }

        var hiddenInput = form.querySelector('.variant-id-input');
        if (hiddenInput) hiddenInput.value = variantId;

        form.dataset.qvVariantVerified = 'true';

        if (form.requestSubmit) {
            form.requestSubmit();
        } else {
            form.submit();
        }
    });
}, true);

// ===== Close popups on Escape key =====
document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
        var qbPopup = document.querySelector('[data-qb-popup]');
        var sgPopup = document.querySelector('[data-sg-popup]');
        var overlay = document.querySelector('[data-qb-overlay]');
        if (qbPopup) qbPopup.hidden = true;
        if (sgPopup) sgPopup.hidden = true;
        if (overlay) overlay.hidden = true;
    }
});

// ===== Wait for theme's cart drawer to open, then close our quick-buy popup =====
function waitForCartDrawerAndClosePopup() {
    var closed = false;

    function closePopupNow() {
        if (closed) return;
        closed = true;
        document.querySelector('[data-qb-popup]').hidden = true;
        document.querySelector('[data-sg-popup]').hidden = true;
        document.querySelector('[data-qb-overlay]').hidden = true;

        var qbBodyEl = document.querySelector('[data-qb-body]');
        if (qbBodyEl) qbBodyEl.classList.remove('qbBodyProcessing');

        observer.disconnect();
    }

    // Watch common cart-drawer selectors for an "open" state
    var drawerSelectors = 'cart-drawer, cart-notification, #cart-drawer, #CartDrawer, [data-cart-drawer]';

    var observer = new MutationObserver(function () {
        var drawerEl = document.querySelector(drawerSelectors);
        if (drawerEl) {
            var isOpen =
                drawerEl.hasAttribute('open') ||
                drawerEl.classList.contains('active') ||
                drawerEl.classList.contains('is-open') ||
                drawerEl.getAttribute('aria-hidden') === 'false';

            if (isOpen) {
                closePopupNow();
            }
        }
    });

    observer.observe(document.body, {
        attributes: true,
        subtree: true,
        attributeFilter: ['open', 'class', 'aria-hidden']
    });

    // Fallback: close after 3s no matter what, so user isn't stuck waiting
    setTimeout(closePopupNow, 3000);
}


(function () {
  function hideCartDialog() {
    const el = document.querySelector('coretex-dialog#cartBox');
    if (!el) return;
    const dialogEl = el.shadowRoot
      ? el.shadowRoot.querySelector('dialog')
      : el.querySelector('dialog');
    if (dialogEl) {
      dialogEl.close();
    }
  }

  const observer = new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && (
              node.id === 'gokwik-modal-wrapper' ||
              (node.querySelector && node.querySelector('#gokwik-modal-wrapper'))
           )) {
          hideCartDialog();
          return;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
